export enum Role {
	ADMIN = 'ADMIN',
	TM = 'TM',
	PEA = 'PEA',
	LEO = 'LEO',
}
